import React, {Fragment, useEffect, useState} from "react";
import {useForm} from 'react-hook-form';
import "../../css/sismo_sentido.css";
import Boton from "./Boton";

import MensajeValidacion from "./MensajeValidacion";

export default function Pagina(props) {   
    return (
        <div className="Formulario">            
            <div className="BarraTitulo">{props.titulo}</div>
            <div className="BarraDibujo">
                <img src={props.imgSrc} alt={props.imgAlt} height="80" />
            </div>
            
            <div className="BarraExplicacion">
                <div className="BarraExplicacionInterno">
                    {props.explicacion}
                </div>
            </div>
            <div className="ContenidoPrincipal">
                <form
                onSubmit={props.handleSubmit(props.onSubmit, onError)}
                className="ContenidoPrincipalForma">
                    { props.contenidoPrincipal }
                   
                    { props.botonesNavegacion }
                </form>
            </div>
            
            <PieDePagina/>
    
        </div>
    );
}
const onError = (errors, e) => {
    console.log("forma no pudo hacer submit")
    console.log(errors, e);
}
const miOnSubmit =(props)=> {
    console.log("form.onsubmit")
    props.handleSubmit(props.onSubmit)
}

export const PieDePagina =(props)=> {
    return (
        <div className="PieDePagina">
        Dirección: Diagonal 53 No 34 - 53 Bogotá D.C. Colombia, Teléfono: (571)220 0200 - (571)220 0100 - (571)222 1811, Fáx: (571) 222 07 97<br/>
        Todos los derechos reservados 2016-2017 Apartado Aéreo 4865<br/>
        <a href="https://www2.sgc.gov.co/Paginas/terminos-y-condiciones.aspx">Políticas de privacidad y términos de uso</a> | 
        <a href="https://www2.sgc.gov.co/Nosotros/NuestrasSedes/Paginas/nuestras-sedes.aspx">Nuestras sedes</a> | 
        <a href="mailto:cliente@sgc.gov.co">Contáctenos</a> | 
        <a href="https://www2.sgc.gov.co/Paginas/notificaciones-judiciales.aspx">Notificaciones Judiciales</a> | 
        <a href="https://www2.sgc.gov.co/AtencionAlCiudadano/Paginas/PQRDS.aspx">PQRDS</a>
        </div>
    )
}

export const buscarPagina = (id, paginas) => {
    for (var i = 0; i < paginas.length; i++) {
        let pag = paginas[i];
        if (pag.id == id) {
            return pag.componente;
        }            
    }
    return null;
}

export const CheckboxReactHookForm=({reg, handleChange, id, value, label, errors}) =>{
    return (
        <React.Fragment>
        <input type="checkbox" 
        ref={reg.ref}
        onChange={(e) => {
            reg.onChange(e);
            if (handleChange)
                handleChange(e);
        }}
        onBlur={(e) => {
            reg.onBlur(e);
        }}        
        id={id} name={reg.name} value={value}/>
        <label htmlFor={id}>{label}</label>        
        </React.Fragment>
    );
}

export const esMayorOIgualACero = (valor) => {  
    console.log("validando mayor o igual a cero " + valor)
    return parseInt(valor) >= 0;
};